export default __webpack_public_path__ + "static/media/settings-minus.974bb54e.svg";